<div class="modal-header">
    <div
        class="modal-title h4"
        role="heading"
        aria-level="1"
    >
        {{ config.header }}
    </div>
    <button
        type="button"
        class="close"
        [attr.aria-label]="i18n._763_CLOSE | translate"
        (click)="activeModal.dismiss('dismiss')"
    >
        <cmps-icon svgIcon="close"></cmps-icon>
    </button>
</div>
<div class="modal-body">
    <ng-template #container></ng-template>
</div>
<div class="modal-footer">
    <button
        type="button"
        class="btn btn-primary"
        (click)="activeModal.close('close')"
    >
        {{ i18n._763_CLOSE | translate }}
    </button>
</div>
